import React from "react";
import { bannerVideo, photoBooth } from "../assets";
import Button from "./common/Button";
import Navbar from "./Navbar";

const Header = () => {
  return (
    <header className="relative h-[40vh] md:h-[50vh] lg:h-screen flex justify-center overflow-hidden">
      <Navbar />
      <video autoPlay loop muted className="absolute w-full blur-[4px]">
        <source src={bannerVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="absolute top-[90%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-full h-96 bg-gradient-to-b from-transparent via-black to-black" />
      <div className="absolute top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] w-full flex flex-col items-center text-center gap-5 lg:gap-20">
        <div className="flex flex-col items-center mt-20 mb-5">
          <p className="text-[12px] md:text-[16px] lg:text-[20px] font-light text-white capitalize">
            LIGHT IS THE PAINT BRUSH, THE WORLD IS YOUR CANVAS
          </p>
          <h1 className="text-[32px] font-gunterz md:text-[62px] lg:text-[75px] font-extrabold text-white">
            MIXED REALITY
          </h1>
          <img className="w-56 md:w-80 lg:w-[500px]" src={photoBooth} alt="" />
          {/*
          <h1 className="text-2xl lg:text-6xl font-extrabold text-white">
            PHOTOBOOTH
          </h1>
          */}
        </div>
        <Button
          round="rounded-[100px]"
          name="BOOK NOW"
          onClick={() => (window.location.hash = "#connect")}
        />
      </div>
    </header>
  );
};
export default Header;
